var React = require('react');

function ChevRightWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 4070","transform":"translate(0 20) rotate(-90)"},React.createElement("path",{"data-name":"Path 5205","d":"M10.021,11.718a1.723,1.723,0,0,0,1.2-.5l8.274-8.275A1.726,1.726,0,1,0,17.057.5L10,7.56,2.943.5A1.726,1.726,0,1,0,.508,2.948l8.274,8.275A1.723,1.723,0,0,0,10.021,11.718Z","transform":"translate(0)","fill":"#fff"})));
}

ChevRightWhite.defaultProps = {"width":"11.719","height":"20","viewBox":"0 0 11.719 20"};

module.exports = ChevRightWhite;

ChevRightWhite.default = ChevRightWhite;
